const PROPERTY_TYPE_FILTER = 'PROPERTY_TYPE-';
const CHAIN_FILTER = 'CHAIN-';

export const FilterParams = {
    compose({ propertyType, chain } = {}) {
        const filters = [];
        if (typeof propertyType === 'string' && propertyType !== '') {
            filters.push(`${PROPERTY_TYPE_FILTER}${propertyType}`);
        }
        if (typeof chain === 'string' && chain !== '') {
            filters.push(`${CHAIN_FILTER}${chain}`);
        }
        return filters.length > 0 ? `filters=${filters.join('+')}` : '';
    },
};
